// extracted by mini-css-extract-plugin
module.exports = {"list":"Informations_list__4Em8g"};